import { render } from "./AddNewHeadphones.vue?vue&type=template&id=912bb304&lang=html"
import script from "./AddNewHeadphones.vue?vue&type=script&lang=js"
export * from "./AddNewHeadphones.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__